import Label from '@/components/ui/label/label';
export default Label;
